import { RouteConfig } from 'vue-router'
import { customMenuLinkRouteNames } from '@/routes/constants/location'

const CustomMenuLinkPage = () =>
  import(
    /* webpackChunkName: "custom-menu-link" */ '@/pmd/pages/agency/CustomMenuLinkPage.vue'
  )

export const customMenuLinkRoute: RouteConfig[] = [
  {
    path: 'custom-menu-link/:id',
    name: customMenuLinkRouteNames.default,
    component: CustomMenuLinkPage,
  },
]
